import { httpClient } from '@/shared/api/client.ts'
import { RefreshResponse } from '@/domains/auth/api/types'

export function refresh() {
  return httpClient.get('member/refresh').json<RefreshResponse>()
}
